import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12 2.452H4A2.748 2.748 0 0 0 1.251 5.2v5.6A2.748 2.748 0 0 0 4 13.552h8a2.748 2.748 0 0 0 2.75-2.75V5.2A2.748 2.748 0 0 0 12 2.452Zm-9.25 3.9h1.44v2.1H2.751Zm2.94 0h3.05v2.1H5.691Zm4.55 0h3.01v2.1h-3.01ZM4 3.952h8a1.227 1.227 0 0 1 1.19.9H2.811A1.227 1.227 0 0 1 4 3.952ZM2.751 10.8v-.85h1.44v2.1H4a1.25 1.25 0 0 1-1.249-1.25Zm2.94-.85h3.05v2.1h-3.05Zm7.56.85A1.25 1.25 0 0 1 12 12.052h-1.76v-2.1h3.01Z';
const draw24px =
  'M20,3.25H4A2.75,2.75,0,0,0,1.25,6V18A2.75,2.75,0,0,0,4,20.75H20A2.75,2.75,0,0,0,22.75,18V6A2.75,2.75,0,0,0,20,3.25ZM2.75,8.75h2.5v4.5H2.75Zm4,0h6.5v4.5H6.75Zm8,0h6.5v4.5h-6.5ZM2.75,6A1.25,1.25,0,0,1,4,4.75H20A1.25,1.25,0,0,1,21.25,6V7.25H2.75Zm0,12V14.75h2.5v4.5H4A1.25,1.25,0,0,1,2.75,18Zm4-3.25h6.5v4.5H6.75ZM21.25,18A1.25,1.25,0,0,1,20,19.25H14.75v-4.5h6.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TableIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'table'),
) as IconWithRender;

TableIcon.displayName = 'TableIcon';
TableIcon.propTypes = Icon.propTypes;
TableIcon.renderIcon = (props) => <TableIcon {...props} />;
export default TableIcon;
